import SEO from '../components/SEO';

const privacySections = [
  {
    title: "Information We Collect",
    items: [
      "Booking details you share with us (name, contact, event specifics, preferred services).",
      "Correspondence records - emails, DMs, or forms submitted via letsfaceit.studio.",
      "Usage data gathered through basic analytics to understand which services guests view most.",
    ],
  },
  {
    title: "How We Use It",
    items: [
      "Coordinate consultations, schedules, and artist pairings that match your booking.",
      "Send confirmations, invoices, or updates tied to an active request.",
      "Improve our site performance and service experience through aggregated insights.",
    ],
  },
  {
    title: "What We Don't Do",
    items: [
      "Sell, trade, or rent your data to other studios or marketers.",
      "Store payment details on our servers - transactions route through secure processors.",
    ],
  },
  {
    title: "Your Choices",
    items: [
      "Update or delete your information anytime by emailing hello@letsfaceitcosmetics.com.",
      "Opt out of marketing notes by using the unsubscribe prompt in any email.",
    ],
  },
];

export default function Privacy() {
  return (
    <>
      <SEO
        title="Privacy Policy"
        description="Learn how Let's Face It Studio protects your personal information. We collect only what's necessary and keep your data secure."
        canonical="https://letsfaceitcosmetics.com/privacy"
      />
      <section className="fixed top-0 left-0 h-full w-full overflow-y-auto bg-gradient-to-b from-[#f1ede7] via-[#ece6de] to-[#e4ded4] text-[#161616] mt-[70px] md:mt-[100px] pb-20 md:pb-32 lg:pb-36">
        <div className="mx-auto max-w-3xl px-4 py-11 xsm:py-[58px] sm:py-[85px] sm:px-8">
          <header className="space-y-4 text-center">
            <span className="text-xs uppercase tracking-[0.4em] text-[#5b5141]">Privacy Policy</span>
            <h1 className="font-mak text-4xl leading-tight text-[#1b1b1b] sm:text-5xl mt-4">
              Protecting your details is non-negotiable.
            </h1>
            <p className="text-[18px] leading-relaxed text-[#3c3c3c] sm:text-xl">
              We collect only what we need to craft your session and keep it for as long as necessary. This page outlines
              how that information flows through the studio and the control you have over it.
            </p>
          </header>

          <div className="mt-10 space-y-10">
            {privacySections.map((section) => (
              <article key={section.title} className="space-y-3">
                <h2 className="text-sm font-semibold uppercase tracking-[0.3em] text-[#5b5141]">
                  {section.title}
                </h2>
                <ul className="list-disc space-y-2 pl-5 text-base leading-relaxed text-[#3c3c3c]">
                  {section.items.map((item) => (
                    <li key={item}>{item}</li>
                  ))}
                </ul>
              </article>
            ))}
          </div>

          <footer className="mt-12 border-t border-[#d9cbb8] pt-6 text-left text-sm text-[#3c3c3c] sm:text-base">
            Need more detail? Email{" "}
            <a href="mailto:hello@letsfaceitcosmetics.com" className="underline decoration-[#cbbda9] decoration-2 underline-offset-4">
              hello@letsfaceitcosmetics.com
            </a>{" "}
            and we&apos;ll respond within two business days.
          </footer>
        </div>
      </section>
    </>
  );
}
